export const updateBreadcrumbTitle = (pathname: string, param?: string) => {
  const path = pathname.split("/");
  let titles: String[] = ["Parceiros"];
  if (path[path.length - 1] == "vendors") {
    titles = ["Parceiros"];
  } else if (path[path.length - 1] == "users") {
    titles = ["Parceiro", "Usuários"];
  } else if (path[path.length - 1] == "benefits") {
    titles = ["Parceiro", "Parcerias"];
  } else if (path[path.length - 2] == "benefits" && param) {
    titles = ["Parceria"];
  }
  return titles;
};
